module.exports = __webpack_public_path__ + "static/aerisi_kalinoth-249804442da2c4419776e54410ac7e19.jpeg";